module.exports = __webpack_public_path__ + "img/image13.b0bb871f.jpg";